import { Badge, type BadgeVariant, IconTile } from "@design";
import { Workflow } from "lucide-react";
import { useTranslation } from "react-i18next";

export function FlowIcon() {
  return (
    <IconTile variant="neutral">
      <Workflow size={16} aria-hidden />
    </IconTile>
  );
}

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  completed: "success",
  running: "info",
  paused: "warning",
  pending: "neutral",
  failed: "danger",
  cancelled: "neutral",
};
const STATUSES = ["completed", "running", "paused", "pending", "failed", "cancelled"] as const;
type Status = (typeof STATUSES)[number];

export function FlowStatusBadge({ status }: Readonly<{ status: string }>) {
  const { t } = useTranslation("workflows");
  const known = (STATUSES as readonly string[]).includes(status) ? (status as Status) : undefined;
  return (
    <Badge variant={STATUS_VARIANT[status] ?? "neutral"} size="compact">
      {known ? t(`status.${known}`) : status}
    </Badge>
  );
}
